import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import FinancingSection from './components/FinancingSection';
import MembershipSection from './components/MembershipSection';
import WhyChooseUs from './components/WhyChooseUs';
import ReviewsSection from './components/ReviewsSection';
import ServiceAreasHome from './components/ServiceAreasHome';
import CommercialSection from './components/CommercialSection';
import CareersSection from './components/CareersSection';
import AcquisitionSection from './components/AcquisitionSection';
import FinalCTA from './components/FinalCTA';
import MobileCallBar from './components/MobileCallBar';

const HomePage = () => (
  <div className="min-h-screen bg-white pb-20 lg:pb-0">
    <Navbar />
    <HeroSection />
    <ServicesOverview />
    <FinancingSection />
    <MembershipSection />
    <WhyChooseUs />
    <ReviewsSection />
    <ServiceAreasHome />
    <CommercialSection />
    <CareersSection />
    <AcquisitionSection />
    <FinalCTA />
    <Footer />
    <MobileCallBar />
  </div>
);

export default HomePage;
